(() => {
  const checkboxSelector = '[data-cart-terms-checkbox]';

  const syncCheckoutButton = (checkbox) => {
    const checkoutStack = checkbox.closest('.gyrol-cart__checkout-stack');
    const checkoutButton = checkoutStack?.querySelector('[data-cart-checkout]');

    if (!checkoutButton) return;
    checkoutButton.disabled = checkoutButton.dataset.cartEmpty === 'true' || !checkbox.checked;
  };

  const initialize = (root = document) => {
    if (root.matches?.(checkboxSelector)) syncCheckoutButton(root);
    root.querySelectorAll?.(checkboxSelector).forEach(syncCheckoutButton);
  };

  initialize();

  document.addEventListener('change', (event) => {
    if (event.target.matches?.(checkboxSelector)) syncCheckoutButton(event.target);
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
